<div [class]="className">
  <label [for]="name">{{ label }}</label>
</div>
